import { QualityEventDetailsResponse } from '../types';
import { DigitalSignature } from '../types/digitalSignature';
import { medtechApi } from './index';

const eventDetailsApi = {
  async getEventDetails(company: number, eventId: number): Promise<QualityEventDetailsResponse | undefined> {
    const response = await medtechApi.get(`/v2/${company}/issues/${eventId}`);
    return QualityEventDetailsResponse.parse(response.data);
  },

  async closeEvent(company: number, eventId: number, payload: DigitalSignature): Promise<void> {
    await medtechApi.post(`/v2/${company}/issues/${eventId}/close`, {
      ...payload,
    });
  },

  async reopenEvent(company: number, eventId: number, payload: DigitalSignature): Promise<void> {
    await medtechApi.post(`/quality-events/${company}/issues/${eventId}/reopen`, {
      ...payload,
    });
  },

  async rejectEvent(companyId: number, eventId: number, payload: DigitalSignature): Promise<void> {
    await medtechApi.post(`/quality-events/${companyId}/issues/${eventId}/change-status`, {
      ...payload,
      status: 'rejected',
    });
  },

  async acceptEvent(companyId: number, eventId: number, payload: DigitalSignature): Promise<void> {
    await medtechApi.post(`/quality-events/${companyId}/issues/${eventId}/change-status`, {
      ...payload,
      status: 'open',
    });
  },

  async cancelEvent(companyId: number, eventId: number, payload: DigitalSignature): Promise<void> {
    await medtechApi.post(`/quality-events/${companyId}/issues/${eventId}/change-status`, {
      ...payload,
      status: 'cancelled',
    });
  },
};

export default eventDetailsApi;
